<template>
  <div class="page-container">
    <div class="query-title">合同查询&修改</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button tip="导出" name="export" @click="exportExcel" />
            <table-button v-if="$_has(['WLY002', 'WLYALL'])" tip="审核通过" name="export" @click="applyContract('APPROVE')" />
            <table-button v-if="$_has(['WLY002', 'WLYALL'])" tip="审核拒绝" name="export" @click="applyContract('REJECT')" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #cntrno="{ row }">
              <span class="blue" @click="showApply(row)">{{ row.cntrno }}</span>
            </template>
            <template #channel="{ row }">
              <span>{{ filterChannel(row.channel) }}</span>
            </template>
            <template #chfl="{ row }">
              <span>{{ filterChfl(row.chfl) }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { apiGetContractList, apiApprove } from '@/api/sap/contract'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/contractList'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 40 }
        ],
        data: []
      },
      pageSearch,
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async applyContract(mode) {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      if (!checkedList.length) {
        return this.$message.warning('请选择有效数据！')
      }
      await this.$confirm(`是否确认${mode === 'REJECT' ? '审核拒绝' : '审核通过'}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      const cntrno = checkedList.map(item => item.cntrno)
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        mode,
        cntrno
      }
      const res = await apiApprove(params)
      if (res.MSGTYPE === 'S') {
        this.$message.success(res.MESSAGE)
        this.queryData()
      } else {
        this.$message.error(res.MESSAGE)
      }
    },
    showApply(row) {
      this.$router.push({
        path: '/wly/contract/detail',
        query: {
          id: row.cntrno
        }
      })
    },
    filterChannel(channel) {
      return channel.map(v => v.chl_name).join(',')
    },
    filterChfl(channel) {
      return channel.map(v => v.value_kt).join(',')
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        mv_role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiGetContractList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 导出全部 导出本页
    async exportExcel() {
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        mv_role: this.$store.getters.role.ROLE,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, apiGetContractList)
      data.forEach(item => {
        item.channel = this.filterChannel(item.channel)
        item.chfl = this.filterChfl(item.chfl)
      })
      frontExport(this.gridOptions.columns, data, '合同信息')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/contract-manage/contractList.vue